<script lang="ts">
  let {
    src,
    name,
    size = 20,
  }: { src: string | null; name: string | null; size?: number } = $props();

  let failed = $state(false);

  const initial = $derived.by(() => {
    const first = [...(name === null ? "" : name).trim()][0];
    return first === undefined ? "?" : first.toLocaleUpperCase();
  });
  const showImage = $derived(src !== null && !failed);
</script>

{#if showImage}
  <img
    {src}
    alt=""
    loading="lazy"
    width={size}
    height={size}
    style="width: {size}px; height: {size}px"
    class="shrink-0 rounded-pill object-cover"
    onerror={() => (failed = true)}
  />
{:else}
  <span
    aria-hidden="true"
    style="width: {size}px; height: {size}px; font-size: {Math.round(size * 0.45)}px"
    class="grid shrink-0 place-items-center rounded-pill bg-surface-2 font-medium text-ink-2"
  >
    {initial}
  </span>
{/if}
